<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Designation Duties and Responsibilities</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Designation"
              v-model="duties.desDesc"
              :class="classPadding"
              clearable
              @click:clear="clearDesig"
              readonly
            >
              <template slot="append">
                <v-icon @click.stop="searchDesignation">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12">
            <duties-selection
              :show-dense="false"
              :show-select="true"
            ></duties-selection>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
        <template slot="duties" slot-scope="{ item }">
          <v-btn @click.stop="viewDuties(item)" text outlined>View</v-btn>
        </template>
      </list>
      <!-- <router-view /> -->

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-text-field
                label="Designation"
                v-model="editDuties.desDesc"
                :class="classPadding"
                clearable
                @click:clear="clearDesig"
                readonly
              >
                <template slot="append">
                  <v-icon @click.stop="searchDesignation">mdi-magnify</v-icon>
                </template>
              </v-text-field>
              <v-col cols="12" xs="12" sm="12" md="12">
                <duties-selection
                  :show-dense="false"
                  :show-select="true"
                ></duties-selection>
              </v-col>
            </v-row>
            <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
            </v-row>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="desigDialog" width="700">
        <v-card>
          <v-card-title>
            <span class="headline">Designation</span>
          </v-card-title>
          <v-card-text>
            <designation>
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="selectDesig(item)" text>Select</v-btn>
              </template>
            </designation>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-dialog v-model="dutiesDialog" width="500" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Duties and Responsibilities</span>
        </v-card-title>
        <v-card-text>
          <v-simple-table dense fixed-header>
            <tbody>
              <tr v-for="(item, key) in selectedDuties" :key="key">
                <td>
                  <span v-html="item.dutiesResponsibilitiesDesc">{{
                    item.dutiesResponsibilitiesDesc
                  }}</span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import Designation from "../designation/List";
import DutiesSelection from "../duties-responsibilites/PaginationSelection";
import EventBus from "../../../../../events/eventBus";
import _ from "lodash";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/desigDutiesRes";
const API_ENDPOINT_DUTIES = "/api/dutiesRes";
export default {
  metaInfo: {
    title: "Designation Duties and Responsibilities",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  components: {
    List,
    Designation,
    DutiesSelection,
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    duties: {},
    componentKey: 0,
    editDuties: {},
    editDialog: false,
    desigDialog: false,
    desigDuties: [],
    selectedDuties: [],
    dutiesDialog: false,
  }),
  methods: {
    // ...mapActions("movementTypeDetails", ["selectMovementTypeDetails"]),
    save() {
      this.isSaving = true;

      this.desigDuties.forEach((item) => {
        item.desCode = this.duties.desCode;
      });

      this.$axios
        .post(`${API_ENDPOINT}`, this.desigDuties)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editDuties.desCode = rel.desCode;
      this.editDuties.desDesc = rel.desDesc;
      this.editDialog = true;
      //var codes = map(item)
      this.getByDesCode(item.desCode);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete",
      }).then((res) => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.desCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.duties = {};
      this.forceRerender();
      this.editDialog = false;
      this.clearSelection();
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;
      this.desigDuties.forEach((item) => {
        item.desCode = this.editDuties.desCode;
      });

      this.$axios
        .post(`${API_ENDPOINT}?mod=update`, this.desigDuties)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    searchDesignation() {
      this.desigDialog = true;
    },
    selectDesig(item) {
      if (!this.editDialog) {
        this.duties.desCode = item.desCode;
        this.duties.desDesc = item.desDesc;
      } else {
        this.editDuties.desCode = item.desCode;
        this.editDuties.desDesc = item.desDesc;
      }
      this.desigDialog = false;
    },
    clearDesig() {
      if (!this.editDialog) {
        this.duties.desCode = null;
        this.duties.desDesc = null;
      } else {
        this.editDuties.desCode = null;
        this.editDuties.desDesc = null;
      }
    },
    viewDuties(item) {
      this.getByDesCode(item.desCode);
      this.dutiesDialog = true;
    },
    getByDesCode(desCode) {
      this.$axios
        .get(`${API_ENDPOINT}/${desCode}`)
        .then(({ data }) => {
          this.selectedDuties = data;
          if (!_.isEmpty(data)) {
            var codes = _.map(data, "dutiesResponsibilitiesCode");
            this.getDuties(codes);
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    clearSelection() {
      EventBus.$emit("CLEAR_DUTIES_RES");
    },
    getDuties(codes) {
      this.$axios
        .post(`${API_ENDPOINT_DUTIES}/codes`, codes)
        .then(({ data }) => {
          EventBus.$emit("TOGGLE_SELECTED_DUTIES_RES", data);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
  },
  mounted() {
    EventBus.$on("SELECTED_DUTIES_RES", (payload) => {
      this.desigDuties = payload;
    });
  },
  created() {
    this.getUserAccessRights("DesDutRes");
  },
  watch: {
    editDialog(val) {
      if (!val) {
        this.clearSelection();
      }
    },
    dutiesDialog(val) {
      if (!val) {
        this.clearSelection();
      }
    },
  },
};
</script>
